// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Community Share Modal System ─── */

.share-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(4, 12, 10, 0.84);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
  box-sizing: border-box;
}

.share-modal-container {
  background: linear-gradient(180deg, #0d1e1a 0%, #081512 100%);
  border: 1px solid rgba(72, 209, 204, 0.28);
  border-radius: 20px;
  width: 100%;
  max-width: 580px;
  max-height: calc(90vh - 20px);
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.88), 0 0 35px rgba(72, 209, 204, 0.16);
  overflow: hidden;
  color: #f1f5f9;
  position: relative;
  z-index: 1000000;
}

/* Header */
.share-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 1px solid rgba(72, 209, 204, 0.12);
  background: rgba(13, 30, 26, 0.6);
}

.share-header-title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}

.share-type-avatar {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.avatar-ballot {
  background: rgba(72, 209, 204, 0.12);
  border: 1px solid rgba(72, 209, 204, 0.3);
}

.avatar-short {
  background: rgba(45, 212, 191, 0.12);
  border: 1px solid rgba(45, 212, 191, 0.3);
}

.share-modal-title {
  font-size: 1.12rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  letter-spacing: -0.01em;
}

.share-modal-subtitle {
  font-size: 0.8rem;
  color: #94a3b8;
  margin: 2px 0 0 0;
}

.btn-share-close {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #94a3b8;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-share-close:hover {
  background: rgba(239, 68, 68, 0.18);
  border-color: rgba(239, 68, 68, 0.4);
  color: #f87171;
  transform: scale(1.05);
}

/* Item Preview Card */
.share-item-preview-card {
  margin: 14px 20px 6px 20px;
  background: rgba(20, 42, 37, 0.5);
  border: 1px solid rgba(72, 209, 204, 0.16);
  border-radius: 14px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.share-item-ballot-icon-box {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: rgba(72, 209, 204, 0.1);
  border: 1px solid rgba(72, 209, 204, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.share-item-thumb-box {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
  background: #06110f;
  border: 1px solid rgba(45, 212, 191, 0.2);
}

.share-item-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.share-item-thumb-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.share-item-details {
  flex: 1 1;
  min-width: 0;
}

.share-item-type-tag {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #48D1CC;
  display: inline-block;
  margin-bottom: 2px;
}

.share-item-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.share-item-subtext {
  font-size: 0.74rem;
  color: #94a3b8;
  margin: 2px 0 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Modal Body */
.share-modal-body {
  padding: 14px 20px 20px 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.share-modal-body::-webkit-scrollbar {
  width: 6px;
}

.share-modal-body::-webkit-scrollbar-thumb {
  background: rgba(72, 209, 204, 0.2);
  border-radius: 4px;
}

/* Section Header */
.share-section-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
}

.share-section-title-wrap {
  display: flex;
  align-items: center;
  gap: 7px;
}

.share-section-title {
  font-size: 0.88rem;
  font-weight: 700;
  color: #e2e8f0;
}

.share-section-desc {
  font-size: 0.78rem;
  color: #94a3b8;
}

/* Search Box */
.share-comm-search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(13, 30, 26, 0.8);
  border: 1px solid rgba(72, 209, 204, 0.2);
  border-radius: 10px;
  padding: 8px 12px;
  margin-bottom: 10px;
}

.share-comm-search-input {
  background: transparent;
  border: none;
  outline: none;
  color: #ffffff;
  font-size: 0.82rem;
  width: 100%;
}

.share-comm-search-input::placeholder {
  color: #64748b;
}

.btn-clear-search {
  background: transparent;
  border: none;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
}

.btn-clear-search:hover {
  color: #fff;
}

/* Communities List */
.share-communities-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 240px;
  overflow-y: auto;
  padding-right: 4px;
}

.share-communities-list::-webkit-scrollbar {
  width: 5px;
}

.share-communities-list::-webkit-scrollbar-thumb {
  background: rgba(72, 209, 204, 0.2);
  border-radius: 3px;
}

.share-loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 28px 0;
  font-size: 0.82rem;
  color: #94a3b8;
}

.share-empty-communities {
  background: rgba(13, 30, 26, 0.5);
  border: 1px dashed rgba(72, 209, 204, 0.25);
  border-radius: 14px;
  padding: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.share-empty-icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(72, 209, 204, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.share-empty-communities h5 {
  font-size: 0.92rem;
  font-weight: 600;
  color: #fff;
  margin: 0 0 4px 0;
}

.share-empty-communities p {
  font-size: 0.78rem;
  color: #94a3b8;
  margin: 0 0 12px 0;
  max-width: 380px;
  line-height: 1.4;
}

.btn-explore-communities {
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  border: none;
  color: #ffffff;
  padding: 7px 16px;
  border-radius: 9px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-explore-communities:hover {
  filter: brightness(1.15);
  transform: translateY(-1px);
}

.share-no-match {
  padding: 16px;
  text-align: center;
  font-size: 0.8rem;
  color: #94a3b8;
}

/* Community Card */
.share-community-card {
  background: rgba(13, 30, 26, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.share-community-card:hover {
  background: rgba(20, 48, 42, 0.8);
  border-color: rgba(72, 209, 204, 0.4);
  transform: translateX(3px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
}

.share-comm-avatar-wrap {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
}

.share-comm-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.share-comm-avatar-placeholder {
  width: 100%;
  height: 100%;
  background: rgba(72, 209, 204, 0.15);
  border: 1px solid rgba(72, 209, 204, 0.3);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  font-weight: 700;
  color: #48D1CC;
}

.share-comm-info {
  flex: 1 1;
  min-width: 0;
}

.share-comm-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.share-comm-name {
  font-size: 0.88rem;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

.share-comm-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.68rem;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 6px;
}

.badge-city {
  background: rgba(20, 184, 166, 0.15);
  color: #2dd4bf;
  border: 1px solid rgba(20, 184, 166, 0.3);
}

.badge-political {
  background: rgba(72, 209, 204, 0.15);
  color: #48D1CC;
  border: 1px solid rgba(72, 209, 204, 0.3);
}

.badge-profession {
  background: rgba(56, 189, 248, 0.15);
  color: #38bdf8;
  border: 1px solid rgba(56, 189, 248, 0.3);
}

.badge-gated {
  background: rgba(212, 175, 55, 0.15);
  color: #f6e05e;
  border: 1px solid rgba(212, 175, 55, 0.3);
}

.badge-open {
  background: rgba(148, 163, 184, 0.15);
  color: #cbd5e1;
  border: 1px solid rgba(148, 163, 184, 0.25);
}

.share-comm-meta {
  margin-top: 3px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.share-comm-members {
  font-size: 0.72rem;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 4px;
}

.btn-share-to-comm {
  background: rgba(72, 209, 204, 0.12);
  border: 1px solid rgba(72, 209, 204, 0.3);
  color: #48D1CC;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.share-community-card:hover .btn-share-to-comm {
  background: #3BB3AE;
  border-color: #48D1CC;
  color: #06110f;
  font-weight: 700;
}

/* External Sharing Section */
.external-share-section {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 14px;
}

.share-external-buttons {
  display: flex;
  gap: 10px;
  margin-top: 8px;
}

.btn-external-share {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 11px;
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-apps-share {
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  border: 1px solid rgba(72, 209, 204, 0.3);
  color: #ffffff;
}

.btn-apps-share:hover {
  filter: brightness(1.15);
  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.3);
}

.btn-copy-share {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #f1f5f9;
}

.btn-copy-share:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(72, 209, 204, 0.4);
}

.btn-copy-share.copied {
  background: rgba(16, 185, 129, 0.15);
  border-color: rgba(16, 185, 129, 0.4);
}

@media (max-width: 640px) {
  .share-modal-container {
    max-height: 94vh;
  }
  
  .share-item-preview-card {
    margin: 10px 14px 4px 14px;
  }
  
  .share-modal-body {
    padding: 10px 14px 16px 14px;
  }

  .share-external-buttons {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Shared/ShareModal.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,oFAAoF;EACpF,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;EACd,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* ─── Community Share Modal System ─── */\n\n.share-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(4, 12, 10, 0.84);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  z-index: 999999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 16px;\n  box-sizing: border-box;\n}\n\n.share-modal-container {\n  background: linear-gradient(180deg, #0d1e1a 0%, #081512 100%);\n  border: 1px solid rgba(72, 209, 204, 0.28);\n  border-radius: 20px;\n  width: 100%;\n  max-width: 580px;\n  max-height: calc(90vh - 20px);\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.88), 0 0 35px rgba(72, 209, 204, 0.16);\n  overflow: hidden;\n  color: #f1f5f9;\n  position: relative;\n  z-index: 1000000;\n}\n\n/* Header */\n.share-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 22px;\n  border-bottom: 1px solid rgba(72, 209, 204, 0.12);\n  background: rgba(13, 30, 26, 0.6);\n}\n\n.share-header-title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.share-type-avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.avatar-ballot {\n  background: rgba(72, 209, 204, 0.12);\n  border: 1px solid rgba(72, 209, 204, 0.3);\n}\n\n.avatar-short {\n  background: rgba(45, 212, 191, 0.12);\n  border: 1px solid rgba(45, 212, 191, 0.3);\n}\n\n.share-modal-title {\n  font-size: 1.12rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.share-modal-subtitle {\n  font-size: 0.8rem;\n  color: #94a3b8;\n  margin: 2px 0 0 0;\n}\n\n.btn-share-close {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #94a3b8;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-share-close:hover {\n  background: rgba(239, 68, 68, 0.18);\n  border-color: rgba(239, 68, 68, 0.4);\n  color: #f87171;\n  transform: scale(1.05);\n}\n\n/* Item Preview Card */\n.share-item-preview-card {\n  margin: 14px 20px 6px 20px;\n  background: rgba(20, 42, 37, 0.5);\n  border: 1px solid rgba(72, 209, 204, 0.16);\n  border-radius: 14px;\n  padding: 12px 14px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.share-item-ballot-icon-box {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  background: rgba(72, 209, 204, 0.1);\n  border: 1px solid rgba(72, 209, 204, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.share-item-thumb-box {\n  width: 48px;\n  height: 48px;\n  border-radius: 10px;\n  overflow: hidden;\n  flex-shrink: 0;\n  background: #06110f;\n  border: 1px solid rgba(45, 212, 191, 0.2);\n}\n\n.share-item-thumb-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.share-item-thumb-fallback {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.share-item-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.share-item-type-tag {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #48D1CC;\n  display: inline-block;\n  margin-bottom: 2px;\n}\n\n.share-item-title {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.share-item-subtext {\n  font-size: 0.74rem;\n  color: #94a3b8;\n  margin: 2px 0 0 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Modal Body */\n.share-modal-body {\n  padding: 14px 20px 20px 20px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.share-modal-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.share-modal-body::-webkit-scrollbar-thumb {\n  background: rgba(72, 209, 204, 0.2);\n  border-radius: 4px;\n}\n\n/* Section Header */\n.share-section-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 10px;\n}\n\n.share-section-title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.share-section-title {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: #e2e8f0;\n}\n\n.share-section-desc {\n  font-size: 0.78rem;\n  color: #94a3b8;\n}\n\n/* Search Box */\n.share-comm-search-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(13, 30, 26, 0.8);\n  border: 1px solid rgba(72, 209, 204, 0.2);\n  border-radius: 10px;\n  padding: 8px 12px;\n  margin-bottom: 10px;\n}\n\n.share-comm-search-input {\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #ffffff;\n  font-size: 0.82rem;\n  width: 100%;\n}\n\n.share-comm-search-input::placeholder {\n  color: #64748b;\n}\n\n.btn-clear-search {\n  background: transparent;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 0;\n}\n\n.btn-clear-search:hover {\n  color: #fff;\n}\n\n/* Communities List */\n.share-communities-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 240px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.share-communities-list::-webkit-scrollbar {\n  width: 5px;\n}\n\n.share-communities-list::-webkit-scrollbar-thumb {\n  background: rgba(72, 209, 204, 0.2);\n  border-radius: 3px;\n}\n\n.share-loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 28px 0;\n  font-size: 0.82rem;\n  color: #94a3b8;\n}\n\n.share-empty-communities {\n  background: rgba(13, 30, 26, 0.5);\n  border: 1px dashed rgba(72, 209, 204, 0.25);\n  border-radius: 14px;\n  padding: 20px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.share-empty-icon-wrap {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: rgba(72, 209, 204, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n}\n\n.share-empty-communities h5 {\n  font-size: 0.92rem;\n  font-weight: 600;\n  color: #fff;\n  margin: 0 0 4px 0;\n}\n\n.share-empty-communities p {\n  font-size: 0.78rem;\n  color: #94a3b8;\n  margin: 0 0 12px 0;\n  max-width: 380px;\n  line-height: 1.4;\n}\n\n.btn-explore-communities {\n  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);\n  border: none;\n  color: #ffffff;\n  padding: 7px 16px;\n  border-radius: 9px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-explore-communities:hover {\n  filter: brightness(1.15);\n  transform: translateY(-1px);\n}\n\n.share-no-match {\n  padding: 16px;\n  text-align: center;\n  font-size: 0.8rem;\n  color: #94a3b8;\n}\n\n/* Community Card */\n.share-community-card {\n  background: rgba(13, 30, 26, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 10px 14px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.share-community-card:hover {\n  background: rgba(20, 48, 42, 0.8);\n  border-color: rgba(72, 209, 204, 0.4);\n  transform: translateX(3px);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);\n}\n\n.share-comm-avatar-wrap {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.share-comm-avatar {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.share-comm-avatar-placeholder {\n  width: 100%;\n  height: 100%;\n  background: rgba(72, 209, 204, 0.15);\n  border: 1px solid rgba(72, 209, 204, 0.3);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #48D1CC;\n}\n\n.share-comm-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.share-comm-name-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.share-comm-name {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 220px;\n}\n\n.share-comm-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 0.68rem;\n  font-weight: 600;\n  padding: 2px 7px;\n  border-radius: 6px;\n}\n\n.badge-city {\n  background: rgba(20, 184, 166, 0.15);\n  color: #2dd4bf;\n  border: 1px solid rgba(20, 184, 166, 0.3);\n}\n\n.badge-political {\n  background: rgba(72, 209, 204, 0.15);\n  color: #48D1CC;\n  border: 1px solid rgba(72, 209, 204, 0.3);\n}\n\n.badge-profession {\n  background: rgba(56, 189, 248, 0.15);\n  color: #38bdf8;\n  border: 1px solid rgba(56, 189, 248, 0.3);\n}\n\n.badge-gated {\n  background: rgba(212, 175, 55, 0.15);\n  color: #f6e05e;\n  border: 1px solid rgba(212, 175, 55, 0.3);\n}\n\n.badge-open {\n  background: rgba(148, 163, 184, 0.15);\n  color: #cbd5e1;\n  border: 1px solid rgba(148, 163, 184, 0.25);\n}\n\n.share-comm-meta {\n  margin-top: 3px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.share-comm-members {\n  font-size: 0.72rem;\n  color: #94a3b8;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.btn-share-to-comm {\n  background: rgba(72, 209, 204, 0.12);\n  border: 1px solid rgba(72, 209, 204, 0.3);\n  color: #48D1CC;\n  padding: 6px 12px;\n  border-radius: 8px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.share-community-card:hover .btn-share-to-comm {\n  background: #3BB3AE;\n  border-color: #48D1CC;\n  color: #06110f;\n  font-weight: 700;\n}\n\n/* External Sharing Section */\n.external-share-section {\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding-top: 14px;\n}\n\n.share-external-buttons {\n  display: flex;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.btn-external-share {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border-radius: 11px;\n  font-size: 0.84rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-apps-share {\n  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);\n  border: 1px solid rgba(72, 209, 204, 0.3);\n  color: #ffffff;\n}\n\n.btn-apps-share:hover {\n  filter: brightness(1.15);\n  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.3);\n}\n\n.btn-copy-share {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: #f1f5f9;\n}\n\n.btn-copy-share:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(72, 209, 204, 0.4);\n}\n\n.btn-copy-share.copied {\n  background: rgba(16, 185, 129, 0.15);\n  border-color: rgba(16, 185, 129, 0.4);\n}\n\n@media (max-width: 640px) {\n  .share-modal-container {\n    max-height: 94vh;\n  }\n  \n  .share-item-preview-card {\n    margin: 10px 14px 4px 14px;\n  }\n  \n  .share-modal-body {\n    padding: 10px 14px 16px 14px;\n  }\n\n  .share-external-buttons {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
